/* eslint-disable no-underscore-dangle */
/* istanbul ignore file */
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import Container from './Container';
import { ClientHydrationProps } from './ClientHydrationProps';
import setupDevApm from '../../utilities/loggerv2/setupDevApm';

if (process.env.NODE_ENV === 'development') {
  setupDevApm();
}

function ContainerSuccess(props: ClientHydrationProps) {
  const {
    name,
    skus,
    brand,
    price,
    lowestPrice,
    description,
    identification,
    images,
    reviews,
    BV_URL,
    productId,
    returnable,
    dynamicPrice,
    features,
    trueFitEnabled,
    personalizableMaxLength,
    isInsuranceAvailable,
    promotionVoucher,
    digitalDownload,
    insuranceContent,
    roundel,
    linkedAddonServicesContent,
    tradeInValue,
    videos,
    promotionIdentifier,
    appleRichContentKey,
    tradingDepartmentId,
    site,
    weeeEligibilityInd,
    vdpMockEnabled,
    creditOffersMockEnabled,
    hasDeliveryContent,
  } = props;

  return (
    <Container
      name={name}
      skus={skus}
      brand={brand}
      price={price}
      lowestPrice={lowestPrice}
      description={description}
      identification={identification}
      images={images}
      reviews={reviews}
      BV_URL={BV_URL}
      productId={productId}
      features={features}
      returnable={returnable}
      dynamicPrice={dynamicPrice}
      trueFitEnabled={trueFitEnabled}
      personalizableMaxLength={personalizableMaxLength}
      isInsuranceAvailable={isInsuranceAvailable}
      promotionVoucher={promotionVoucher}
      digitalDownload={digitalDownload}
      insuranceContent={insuranceContent}
      roundel={roundel}
      linkedAddonServicesContent={linkedAddonServicesContent}
      tradeInValue={tradeInValue}
      videos={videos}
      promotionIdentifier={promotionIdentifier}
      appleRichContentKey={appleRichContentKey}
      tradingDepartmentId={tradingDepartmentId}
      site={site}
      weeeEligibilityInd={weeeEligibilityInd}
      vdpMockEnabled={vdpMockEnabled}
      creditOffersMockEnabled={creditOffersMockEnabled}
      hasDeliveryContent={hasDeliveryContent}
    />
  );
}
// eslint-disable-next-line no-underscore-dangle
if (window.__product_body_initial_state__) {
  hydrateRoot(
    document.getElementById('productRoot') as HTMLElement,
    ContainerSuccess(window.__product_body_initial_state__),
  );
}
